// CYD Home Goods — scripts propios (vanilla JS, sin librerias externas)

function cydInitReveal() {
  var els = document.querySelectorAll('.cyd-reveal:not(.cyd-visible)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('cyd-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cyd-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function cydInitContadores() {
  var els = document.querySelectorAll('[data-cyd-contador]');
  if (!els.length) return;
  var animar = function (el) {
    var fin = parseFloat(el.getAttribute('data-cyd-contador')) || 0;
    var duracion = 1400;
    var inicio = null;
    var paso = function (ts) {
      if (!inicio) inicio = ts;
      var progreso = Math.min((ts - inicio) / duracion, 1);
      var actual = Math.floor(progreso * fin);
      el.textContent = actual.toLocaleString('es-ES') + (el.getAttribute('data-cyd-sufijo') || '');
      if (progreso < 1) requestAnimationFrame(paso);
      else el.textContent = fin.toLocaleString('es-ES') + (el.getAttribute('data-cyd-sufijo') || '');
    };
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) {
    els.forEach(animar);
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function cydInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-cyd-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-cyd-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-cyd-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-cyd-src');
        var srcset = mini.getAttribute('data-cyd-srcset');
        var alt = mini.getAttribute('data-cyd-alt') || '';
        if (!src) return;
        principal.src = src;
        if (srcset) principal.srcset = srcset;
        principal.alt = alt;
        miniaturas.forEach(function (m) { m.classList.remove('cyd-miniatura--activa'); });
        mini.classList.add('cyd-miniatura--activa');
      });
    });
  });
}

function cydInitVariantes() {
  var forms = document.querySelectorAll('[data-cyd-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-cyd-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-cyd-opcion]');
    var inputId = form.querySelector('[data-cyd-variant-id]');
    var precioEl = form.querySelector('[data-cyd-precio]');
    var precioCompareEl = form.querySelector('[data-cyd-precio-compare]');
    var botonEl = form.querySelector('[data-cyd-boton-comprar]');
    if (!selects.length || !inputId) return;

    function formatoDinero(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function actualizar() {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var encontrada = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
      if (!encontrada) return;
      inputId.value = encontrada.id;
      if (precioEl) precioEl.textContent = formatoDinero(encontrada.price);
      if (precioCompareEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          precioCompareEl.textContent = formatoDinero(encontrada.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (encontrada.available) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.getAttribute('data-cyd-texto-disponible');
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.getAttribute('data-cyd-texto-agotado');
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function cydInitAntesDespues() {
  var els = document.querySelectorAll('[data-cyd-antes-despues]');
  els.forEach(function (el) {
    var input = el.querySelector('.cyd-ad__control');
    if (!input) return;
    var actualizar = function () {
      el.style.setProperty('--cyd-ad-pos', input.value + '%');
    };
    input.addEventListener('input', actualizar);
    actualizar();
  });
}

function cydInitFaq() {
  var grupos = document.querySelectorAll('[data-cyd-faq]');
  grupos.forEach(function (grupo) {
    var items = grupo.querySelectorAll('[data-cyd-faq-item]');
    items.forEach(function (item) {
      var pregunta = item.querySelector('[data-cyd-faq-pregunta]');
      if (!pregunta) return;
      pregunta.addEventListener('click', function () {
        var abierto = item.classList.contains('cyd-faq__item--abierto');
        items.forEach(function (i) { i.classList.remove('cyd-faq__item--abierto'); });
        if (!abierto) item.classList.add('cyd-faq__item--abierto');
      });
    });
  });
}

function cydInitStickyAtc() {
  var barras = document.querySelectorAll('[data-cyd-sticky-atc]');
  barras.forEach(function (barra) {
    var selector = barra.getAttribute('data-cyd-vigila');
    var principal = selector ? document.querySelector(selector) : null;
    var botonSticky = barra.querySelector('[data-cyd-sticky-atc-boton]');
    if (botonSticky && principal) {
      botonSticky.addEventListener('click', function () {
        principal.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    if (!principal || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            barra.classList.remove('cyd-sticky-atc--visible');
          } else if (entry.boundingClientRect.top < window.innerHeight) {
            barra.classList.add('cyd-sticky-atc--visible');
          } else {
            barra.classList.remove('cyd-sticky-atc--visible');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(principal);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  cydInitReveal();
  cydInitContadores();
  cydInitGaleriaProducto();
  cydInitVariantes();
  cydInitAntesDespues();
  cydInitFaq();
  cydInitStickyAtc();
});
